<div class="container">
  <h2>Unable to cancel account request...</h2>
  <div>(because the request has already been verified, cancelled or timed out...)</div>
  <div class="italic">{{ message }}</div>
</div>
